import { useAppSelector } from "../app/hooks";
import { selectHotel } from "../features/hotel/hotelSlice";
import ProductCard from "../components/Extras/ProductCard";
import {
  GTMTrackingAddToCart,
  GTMTrackingViewItemList,
} from "../helpers/GTMTracking";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Modal from "../components/Helpers/Modal";
import { StaticCart } from "../components/StaticCart";
import { useNavigate } from "react-router-dom";
import { TopCart } from "../components/TopCart";

function Extras() {
  const hotel = useAppSelector(selectHotel);
  const navigate = useNavigate();

  const [showProductModal, setShowProductModal] = useState<string | null>(null);
  useEffect(() => {
    GTMTrackingViewItemList();
  }, []);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: "-12px", transition: { duration: 0 } }}
        animate={{ opacity: 1, y: "0px", transition: { duration: 0.4 } }}
        exit={{ opacity: 0, y: "-12px", transition: { duration: 0 } }}
        className="absolute inset-0 overflow-y-auto w-full p-4"
      >
        <TopCart />
        <div className="grid grid-cols-1 gap-4">
          {hotel.Products &&
            hotel.Products.map((product, i) => (
              <ProductCard
                key={i}
                Product={product}
                setShowProductModal={setShowProductModal}
              />
            ))}
        </div>

        <StaticCart
          next={() => {
            // GTM DATALAYER
            GTMTrackingAddToCart();
            navigate("/summary");
          }}
        />
      </motion.div>

      {hotel.Products.map((product, i) => {
        return (
          <Modal
            onClick={() => {
              setShowProductModal(null);
              return false;
            }}
            show={showProductModal == product.Id}
            title={product.Name[hotel.Culture.LanguageCode] ?? product.Name[hotel.DefaultLanguageCode]}
            key={i}
          >
            <div>{product.Description[hotel.Culture.LanguageCode] ?? product.Description[hotel.DefaultLanguageCode]}</div>
          </Modal>
        );
      })}
    </>
  );
}

export default Extras;
